/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { __decorate } from "tslib";
import { customElement, attachShadowTemplate } from '@tylertech/forge-core';
import { BaseComponent } from '../../core/base/base-component';
import { VIEW_CONSTANTS } from './view-constants';
const template = '<template><slot></slot></template>';
const styles = ':host{display:block}:host([hidden]){display:none}';
/**
 * @tag forge-view
 */
let ViewComponent = class ViewComponent extends BaseComponent {
    constructor() {
        super();
        attachShadowTemplate(this, template, styles);
    }
};
ViewComponent = __decorate([
    customElement({
        name: VIEW_CONSTANTS.elementName
    })
], ViewComponent);
export { ViewComponent };
